<template>
    <div
        :id="id"
        class="flex scroll-mt-4 flex-col gap-4"
    >
        <p class="text-lg font-semibold leading-none">
            {{ title }}
            <span v-if="isMandatory" class="font-bold text-red-500">*</span>
        </p>
        <p class="flex justify-between">
            <span>{{ getUserExplanationExtraDropDownItem() }}</span>
        </p>
        <!-- TODO: fix TS issue after this is done https://github.com/formkit/formkit/issues/1450 -->
        <transition name="fade" mode="out-in">
            <FormKitMessages
                :node="dropdownRef?.node"
                :library="FormKitMessagesCustomComponents"
                :sections-schema="
                    // @ts-expect-error
                    {
                        message: {
                            $el: undefined,
                            $cmp: 'Notification',
                            props: {
                                type: 'error'
                            },
                            children: '$message.value'
                        }
                    }"
            />
        </transition>
        <FormKit
            :id="id"
            ref="dropdownRef"
            type="group"
            validation="+validateExtraDropDownItem"
            :validation-rules="{ validateExtraDropDownItem }"
            :validation-messages="{
                validateExtraDropDownItem: getValidationMessageExtraDropdownItem()
            }"
            validation-visibility="blur"
        >
            <FormKit
                v-model="dropDownModel"
                type="select"
                name="input"
                :options="currentOptions"
            />
        </FormKit>
    </div>
</template>

<script setup lang="ts">
    import type { ExtrasProps } from '~/types/local-types'
    import { FormKitMessages } from '@formkit/vue'
    import Notification from '~/components/Notification/Notification.vue'
    import { productForm } from '~/store/productForm'
    import { currencyFormat } from '~/utils/currency-utils'
    const props = defineProps<ExtrasProps>()
    const { t } = useI18n()
    const dropdownRef = ref()
    const isMandatory = (props.minimumSelectionQuantity !== null && props.minimumSelectionQuantity > 0)
    const FormKitMessagesCustomComponents = { Notification: markRaw(Notification) }
    const currentOptions = [
        { label: t('shopPage.product.selectAnItem'), value: null }
    ]
    if (props.items && props.items.length) {
        props.items.forEach((item: any) => {
            currentOptions.push({
                label: item.title + (props.showPrices && item.price ? ` ${currencyFormat(item.price)}` : ''),
                value: item.id
            })
        })
    }
    const dropDownModel = computed({
        get () {
            return Object.keys(productForm().currentProductWithSelectedExtras.extras[props.id].items).find(itemKey => productForm().currentProductWithSelectedExtras.extras[props.id].items[itemKey].selected === true)
        },
        set (val) {
            if (val) {
                // TODO: see if we can move this to the store
                Object.keys(productForm().currentProductWithSelectedExtras.extras[props.id].items).forEach(itemKey => {
                    if (itemKey === val) {
                        productForm().currentProductWithSelectedExtras.extras[props.id].items[val].selected = true
                        productForm().currentProductWithSelectedExtras.extras[props.id].items[val].quantity = 1
                    } else {
                        productForm().currentProductWithSelectedExtras.extras[props.id].items[itemKey].selected = false
                        productForm().currentProductWithSelectedExtras.extras[props.id].items[itemKey].quantity = 0
                    }
                })
            }
        }
    })
    function validateExtraDropDownItem (node: any) {
        if (isMandatory) {
            return node.value.input !== null
        } else {
            return true
        }
    }
    function getUserExplanationExtraDropDownItem () {
        if (isMandatory) {
            return `${t('shopPage.product.selectAtLeast')} ${props.minimumSelectionQuantity} ${props.minimumSelectionQuantity > 1 ? t('shopPage.product.items') : t('shopPage.product.item')}.`
        } else {
            return t('shopPage.product.whatItemsWouldYouLike')
        }
    }
    function getValidationMessageExtraDropdownItem () {
        if (isMandatory) {
            return t('shopPage.product.selectAnItem')
        } else {
            return ''
        }
    }
</script>
